import { panelSnapshotPosts } from './PanelSnapshotPosts';

const postEngagement2Snapshot = {
    id: 'cGFuZWw6NWQ4ZDFjMGYxNjIzYWU2MmEwNGMyOGQ1',
    partnerId: 349,
    clientId: 7101,
    name: 'Duo',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4ZDFjMGYxNjIzYWU2MmEwNGMyOGQ0',
        name: 'Scene 30',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'engagement',
                type: 'postsGrid',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        postInner: {
                            default: 'between',
                            review: '',
                        },
                        postText: {
                            default: 'p-reset pl-15 pr-15 pt-15 pb-05 ta-c',
                            review: 'p-reset pl-2 pr-2 pt-05 pb-05 h-50',
                        },
                        userGroup: {
                            default: 'p-reset p-15',
                            review: 'p-reset pl-2 w-a',
                        },
                        metaGroup: {
                            default: 'p-reset pt-15 pl-15 pr-15 pb-0',
                        },
                        reviewDomain: {
                            default: 'mr-2',
                        },
                        reviewRating: {
                            default: 'pl-2 pb-2 pt-2',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: true,
                    showImageStyles: true,
                    imageFiltersOpen: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: null,
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.0)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    imageTextColor: '#FFF',
                    postImageTextSize: 17,
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 5,
                    imagePostHideText: true,
                    imageFaceDetection: false,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 20,
                    engagementMetricsPosition: 'bottom_left',
                    adsMetricsSize: 30,
                    showTextStyles: false,
                    showText: true,
                    textOnlyColor: '#FFF',
                    postTextOnlySize: 17,
                    postLineClamp: true,
                    postLineClampValue: 5,
                    textFitMin: 20,
                    showPostTextOverlay: false,
                    showUserGroup: true,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 14,
                    userGroupAvatarSize: 20,
                    userGroupNameSize: 14,
                    userGroupScreenNameSize: 11,
                    userGroupPosition: 'bottom',
                    userGroupGradientColor: 'rgba(0,0,0,.3)',
                    userGroupGradientEnabled: false,
                    userGroupGradientDirection: 'bottomToTop',
                    showTimeStamp: false,
                    timeStampSize: 15,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textOnlyBackgroundColor: '',
                    textOnlyTextFormat: 'clamp',
                    textOnlyTeleprompterSpeed: 50,
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    imageBackgroundSize: 'cover',
                    showZeroEngagementValues: false,
                    maxCharacters: 180,
                    teleprompterSpeed: 50,
                    userGroupLayoutType: 'd',
                    postCompositionType: 'a',
                    socialIconBgColor: false,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 17,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 2,
                                },
                                fit: {
                                    min: 10,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 12,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                        message: {
                            enabled: true,
                            size: 13,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    postComposition: 'a',
                    extraPostDataOptions: {
                        enabled: null,
                        color: '',
                        size: 15,
                        value: {
                            format: '1.23k',
                        },
                        border: {
                            enabled: true,
                            color: '',
                        },
                        header: {
                            enabled: false,
                            size: 30,
                            text: '',
                            color: '',
                        },
                    },
                    postTemplate: '',
                    userGroupEffect: 'top',
                    theme: 'primary',
                    showSentiment: true,
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    showIconInUserGroup: false,
                    smartSizeCompositions: {
                        baseline: {
                            postTextOnlySize: 17,
                            postImageTextSize: 17,
                            engagementMetricsSize: 20,
                            userGroupIconSize: 14,
                            userGroupAvatarSize: 20,
                            userGroupNameSize: 14,
                            userGroupScreenNameSize: 11,
                        },
                        optionDefaults: {
                            optionDefaults: {
                                imagePostLineClampValue: 5,
                                postLineClampValue: 5,
                            },
                            classOverrides: {
                                postInner: {
                                    default: 'between',
                                    review: '',
                                },
                                postText: {
                                    default: 'p-reset pl-15 pr-15 pt-15 pb-05 ta-c',
                                    review: 'p-reset pl-2 pr-2 pt-05 pb-05 h-50',
                                },
                                userGroup: {
                                    default: 'p-reset p-15',
                                    review: 'p-reset pl-2 w-a',
                                },
                                metaGroup: {
                                    default: 'p-reset pt-15 pl-15 pr-15 pb-0',
                                },
                                reviewDomain: {
                                    default: 'mr-2',
                                },
                                reviewRating: {
                                    default: 'pl-2 pb-2 pt-2',
                                },
                            },
                        },
                        breakpoints: {
                            m: {
                                options: {
                                    classOverrides: {
                                        postInner: {
                                            default: 'between',
                                            review: '',
                                        },
                                        postText: {
                                            default: 'p-reset pl-1 pr-1 pt-1 pb-05 ta-c',
                                            review: 'p-reset pl-1 pr-1 pt-05 pb-05 h-50',
                                        },
                                        userGroup: {
                                            default: 'p-reset p-1',
                                            review: 'p-reset pl-1 w-a',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pt-1 pl-1 pr-1 pb-0',
                                        },
                                        reviewDomain: {
                                            default: 'mr-1',
                                        },
                                        reviewRating: {
                                            default: 'pl-1 pb-1 pt-1',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-1',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    imagePostLineClampValue: 4,
                                    postLineClampValue: 4,
                                    classOverrides: {
                                        postInner: {
                                            default: 'between',
                                            review: '',
                                        },
                                        postText: {
                                            default: 'p-reset pl-05 pr-05 pt-05 pb-05 ta-c',
                                            review: 'p-reset pl-05 pr-05 pt-05 pb-05 h-50',
                                        },
                                        userGroup: {
                                            default: 'p-reset p-05',
                                            review: 'p-reset pl-05 w-a',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pt-05 pl-05 pr-05 pb-0',
                                        },
                                        reviewDomain: {
                                            default: 'mr-05',
                                        },
                                        reviewRating: {
                                            default: 'pl-05 pb-05 pt-05',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-05',
                                        },
                                    },
                                },
                            },
                            xs: {
                                options: {
                                    imagePostLineClampValue: 4,
                                    postLineClampValue: 4,
                                    classOverrides: {
                                        postInner: {
                                            default: 'between',
                                            review: '',
                                        },
                                        postText: {
                                            default: 'p-reset pl-05 pr-05 pt-05 pb-05 ta-c',
                                            review: 'p-reset pl-05 pr-05 pt-05 pb-05 h-50',
                                        },
                                        userGroup: {
                                            default: 'p-reset p-05',
                                            review: 'p-reset pl-05 w-a',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pt-05 pl-05 pr-05 pb-0',
                                        },
                                        reviewDomain: {
                                            default: 'mr-05',
                                        },
                                        reviewRating: {
                                            default: 'pl-05 pb-05 pt-05',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-05',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    source: 'REPORTING',
                                    reportingEngine: 'LISTENING',
                                    report: 'SPRINKSIGHTS',
                                    pageSize: 12,
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'REACH_COUNT',
                                        },
                                    ],
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1569481200000,
                                        endTime: 1569567599999,
                                    },
                                    filters: [
                                        {
                                            dimensionName: 'TOPIC_GROUP_IDS',
                                            filterType: 'IN',
                                            values: ['5a00b9e4e4b082264ab84227'],
                                        },
                                    ],
                                    showInReplyToPost: false,
                                    projections: [],
                                    groupBys: [],
                                },
                                options: {
                                    count: 300,
                                    imagePreload: false,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                },
                                data: [
                                    {
                                        messageType: 2,
                                        accountId: 999998,
                                        snMsgId: '1176537936575258627',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569343477754,
                                        permalink:
                                            'https://twitter.com/show/status/1176537936575258627',
                                        message:
                                            "In honor of Sprinklr's 10th birthday today, I'm also celebrating the 10lbs I lost from riding my bike to work! #sprinklr10 #sprinklrlife #bikelife https://t.co/dKrY1ueh6M https://t.co/yR4b3ShAwt",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [147, 170],
                                                    url: 'https://t.co/dKrY1ueh6M',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [171, 194],
                                                    url: 'https://t.co/yR4b3ShAwt',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [111, 122],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [123, 136],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [137, 146],
                                                    hashtag: 'bikelife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Austin, TX',
                                            gender: null,
                                            snId: '24314460',
                                            name: 'Jake Trigg',
                                            screenName: 'ATXatLarge',
                                            email: null,
                                            bio:
                                                "Product, Program and Project Manager for high-growth software startups. I'm a click-counter, and focus on empowering others and being of service.",
                                            following: 214,
                                            followers: 85,
                                            favCount: 37,
                                            statusCount: 534,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/ATXatLarge',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1254840369/ATX_Large-logo_normal.png',
                                            createdTime: 1236999001000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bc4be8ae4b03a19f57fb6bb',
                                            participationIndex: 0,
                                            influencerIndex: 38,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Austin, Texas, United States',
                                            lat: 30.26715,
                                            lon: -97.74306,
                                            additional: {
                                                country: 'United States',
                                                state: 'Texas',
                                                code: 'US',
                                                state_code: 'TX',
                                                city: 'Austin',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[0].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 194,
                                            numRetweets: 1,
                                            reachCount: 41730,
                                            numLikes: 17,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 83,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 17,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176342792685019136',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569296951825,
                                        permalink:
                                            'https://twitter.com/show/status/1176342792685019136',
                                        message:
                                            'Time to fly into a new decade! 😂😂 ✈️ #Sprinklr10 #SprinklrLife \n\nHappy Birthday @Sprinklr! https://t.co/NtbSzu2sNQ',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [82, 91],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [93, 116],
                                                    url: 'https://t.co/NtbSzu2sNQ',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [39, 50],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [51, 64],
                                                    hashtag: 'SprinklrLife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'India',
                                            gender: 'M',
                                            snId: '206077671',
                                            name: 'Akshit Dhumal',
                                            screenName: 'akshitdhumal',
                                            email: null,
                                            bio:
                                                'Whatever you do, don’t be another brick in the wall!',
                                            following: 1710,
                                            followers: 822,
                                            favCount: 1336,
                                            statusCount: 2252,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/akshitdhumal',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1175464468802703360/eNKo60Tp_normal.jpg',
                                            createdTime: 1287730322000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '54368820e4b093569d4cbe68',
                                            participationIndex: 0,
                                            influencerIndex: 55,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Bengaluru South, India',
                                            lat: 20,
                                            lon: 77,
                                            additional: {
                                                country: 'India',
                                                code: 'IN',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[1].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 116,
                                            numRetweets: 3,
                                            reachCount: 39126,
                                            numLikes: 10,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 822,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 10,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {
                                            eS: [
                                                {
                                                    title: 'Company',
                                                    pol: 'neutral',
                                                    sc: 1,
                                                    labels: ['time'],
                                                },
                                            ],
                                        },
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    text: {
                                        filter: "post.type == 'text'",
                                    },
                                    image: {
                                        filter: "post.type == 'image'",
                                    },
                                    any: {
                                        filter: 'post.type',
                                    },
                                },
                                panels: [
                                    {
                                        total: 2,
                                        buckets: ['any', -1],
                                    },
                                ],
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '2.08%',
                    right: null,
                    top: '3.72%',
                    bottom: null,
                    width: '95.84%',
                    height: '92.56%',
                    portrait: {
                        left: '3%',
                        top: '2%',
                        width: '94%',
                        height: '96%',
                    },
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Header',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: 'bed3dda7-f116-4b76-9006-3f391de729fc',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_engagement template_duo',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 0,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569528878189,
};
export default postEngagement2Snapshot;
